import * as React from "react";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { useSetStatusForInvestigationEvents } from "security-app/hooks/useSecurityEventsAPI";
import { ConfirmDialog } from "security-app/components/common/Modal";
import SetStatusControl from "security-app/components/SecurityEvents/Alerts/EventDetails/SetStatusControl";
import HelpBlock from "components/bootstrap/HelpBlock";
import Alert from "components/bootstrap/Alert";
const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0;
`;
const StyledHelpBlock = styled(HelpBlock)`
  margin: 2px 0;
`;
const UpdateEventStatusModal = ({ investigationIds, onClose, show, onSuccess = void 0 }) => {
  const [newStatus, setNewStatus] = useState(void 0);
  const { setStatusForInvestigation, settingStatus, isError, error } = useSetStatusForInvestigationEvents();
  const onConfirm = useCallback(async () => {
    if (!newStatus) {
      onClose();
      return;
    }
    try {
      await setStatusForInvestigation({ investigationIds, status: newStatus });
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } catch (e) {
      console.error(e);
    }
  }, [newStatus, investigationIds, setStatusForInvestigation, onClose, onSuccess]);
  return /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show,
      onConfirm,
      confirmDisabled: settingStatus || !newStatus,
      confirmText: "Update",
      onCancel: onClose,
      cancelText: "Skip",
      isLoading: settingStatus,
      title: "Update Event Statuses"
    },
    /* @__PURE__ */ React.createElement(StyledHelpBlock, null, "You can optionally update the status of all events associated with", " ", investigationIds.length > 1 ? `${investigationIds.length} investigations.` : "this investigation."),
    isError ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, (error == null ? void 0 : error.responseMessage) || (error == null ? void 0 : error.message)) : null,
    /* @__PURE__ */ React.createElement(SelectContainer, null, /* @__PURE__ */ React.createElement(SetStatusControl, { width: "100%", onStatusChange: setNewStatus, value: newStatus }))
  );
};
export default UpdateEventStatusModal;
